import ZendeskLink from "./ZendeskLink";

export default function ForMoreInfoZendeskLink({ url }) {
    return <>
        {" "}For MORE information <ZendeskLink url={url}>click here.</ZendeskLink>
    </>
}
